import type { ReactNode } from 'react';
import { RedesignNav } from './RedesignNav';
import { RedesignFooter } from './RedesignFooter';
import { MobileStickyCta } from '@/components/marketing/MobileStickyCta';

interface RedesignShellProps {
  children: ReactNode;
  navActive?: React.ComponentProps<typeof RedesignNav>['active'];
}

export function RedesignShell({ children, navActive }: RedesignShellProps) {
  return (
    <div className="rd-marketing palette-gold density-comfortable min-h-screen">
      <RedesignNav active={navActive} />
      <main>{children}</main>
      <RedesignFooter />
      <MobileStickyCta />
    </div>
  );
}
